var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "calendar-filter" }, [
    _c(
      "div",
      { staticClass: "calendar-filter__container" },
      [
        _c("z-tabs", {
          attrs: { "only-visual": "" },
          on: {
            "toggle-item": function ($event) {
              return _vm.onTabChange($event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return _vm._l(_vm.types, function (type) {
                  return _c(
                    "z-tabs-label",
                    {
                      key: type.id,
                      attrs: { id: type.id, "initial-state": type.selected },
                    },
                    [_vm._v(_vm._s(type.text))]
                  )
                })
              },
              proxy: true,
            },
          ]),
        }),
        _vm._v(" "),
        _c("z-date-picker", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.params.type === "past",
              expression: "params.type === 'past'",
            },
          ],
          staticClass: "calendar-filter__datepicker",
          attrs: { placeholder: _vm.text.datePlaceholder, range: "" },
          model: {
            value: _vm.params.date,
            callback: function ($$v) {
              _vm.$set(_vm.params, "date", $$v)
            },
            expression: "params.date",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }